import PageHero from '../../components/PageHero';
import { Link } from 'react-router-dom';
import './StaticPage.css';

function TermsConditionsPage() {
  return (
    <div className="static-page content-page">
      <PageHero
        title="Terms &amp; Conditions"
        subtitle="Terms of use for WeddingzVenue"
      />
      <div className="content-container">
        <p className="last-updated">Last updated: March 2025</p>
        <p>
          Welcome to WeddingzVenue. By accessing or using our website and services, you agree to be bound
          by these Terms and Conditions. Please read them carefully.
        </p>

        <h2>Use of the platform</h2>
        <p>
          You may use WeddingzVenue to search for wedding venues and vendors, send enquiries, and (where
          applicable) manage your business listing. You agree to use the platform only for lawful purposes
          and in accordance with these terms.
        </p>

        <h2>User accounts</h2>
        <p>
          When you create an account, you are responsible for maintaining the confidentiality of your
          credentials and for all activity under your account. You must provide accurate and complete
          information and update it as needed.
        </p>

        <h2>Enquiries and bookings</h2>
        <p>
          Sending an enquiry through our platform does not create a binding contract between you and the
          venue or vendor. All bookings, payments, and contracts are between you and the respective
          business. WeddingzVenue acts as a discovery and enquiry platform only.
        </p>

        <h2>Business listings</h2>
        <p>
          Venues and vendors who list on WeddingzVenue must ensure that their information, photos, and
          pricing are accurate and up to date. We reserve the right to remove or suspend listings that
          violate our policies or applicable law.
        </p>

        <h2>Intellectual property</h2>
        <p>
          The content, design, and branding of WeddingzVenue are owned by us or our licensors. You may not
          copy, modify, or distribute our content without prior written permission.
        </p>

        <h2>Limitation of liability</h2>
        <p>
          To the fullest extent permitted by law, WeddingzVenue shall not be liable for any indirect,
          incidental, special, or consequential damages arising from your use of the platform or from
          any transaction between you and a venue or vendor.
        </p>

        <h2>Changes</h2>
        <p>
          We may update these terms from time to time. Continued use of the platform after changes
          constitutes acceptance of the revised terms.
        </p>

        <h2>Contact</h2>
        <p>
          For questions about these Terms &amp; Conditions, contact us at{' '}
          <a href="mailto:contact@weddingzvenue.in">contact@weddingzvenue.in</a> or via our{' '}
          <Link to="/contact">Contact</Link> page.
        </p>
      </div>
    </div>
  );
}

export default TermsConditionsPage;
